"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Table", {
    enumerable: true,
    get: function() {
        return Table;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Table = (param)=>{
    let { children, sticky, className = "", // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    responsiveWidth = 1024, sideBorders = true, responsive = false, ...props } = param;
    const { colors } = (0, _Theme.useTheme)();
    const width = responsive ? "".concat(responsiveWidth, "px") : "0px";
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "d21131bf3a2a33e3",
                [
                    responsive ? "auto" : "visible",
                    width,
                    colors.white,
                    sideBorders ? "solid 1px ".concat(colors.border) : "none",
                    colors.border,
                    colors.border,
                    sideBorders ? "8px" : "0",
                    sideBorders ? "separate" : "collapse",
                    colors.border,
                    width,
                    (sticky === null || sticky === void 0 ? void 0 : sticky.top) == null ? "static" : "sticky",
                    (sticky === null || sticky === void 0 ? void 0 : sticky.top) != null ? "".concat(sticky.top, "px") : "auto",
                    (sticky === null || sticky === void 0 ? void 0 : sticky.isStuck) === true ? "3" : "inherit"
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement("table", {
        ...props,
        cellSpacing: "0",
        cellPadding: "0",
        className: _style.default.dynamic([
            [
                "d21131bf3a2a33e3",
                [
                    responsive ? "auto" : "visible",
                    width,
                    colors.white,
                    sideBorders ? "solid 1px ".concat(colors.border) : "none",
                    colors.border,
                    colors.border,
                    sideBorders ? "8px" : "0",
                    sideBorders ? "separate" : "collapse",
                    colors.border,
                    width,
                    (sticky === null || sticky === void 0 ? void 0 : sticky.top) == null ? "static" : "sticky",
                    (sticky === null || sticky === void 0 ? void 0 : sticky.top) != null ? "".concat(sticky.top, "px") : "auto",
                    (sticky === null || sticky === void 0 ? void 0 : sticky.isStuck) === true ? "3" : "inherit"
                ]
            ]
        ]) + " " + ("".concat(className, " ").concat((sticky === null || sticky === void 0 ? void 0 : sticky.isStuck) === true ? "stuck" : "").trim() || "")
    }, children)), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "d21131bf3a2a33e3",
        dynamic: [
            responsive ? "auto" : "visible",
            width,
            colors.white,
            sideBorders ? "solid 1px ".concat(colors.border) : "none",
            colors.border,
            colors.border,
            sideBorders ? "8px" : "0",
            sideBorders ? "separate" : "collapse",
            colors.border,
            width,
            (sticky === null || sticky === void 0 ? void 0 : sticky.top) == null ? "static" : "sticky",
            (sticky === null || sticky === void 0 ? void 0 : sticky.top) != null ? "".concat(sticky.top, "px") : "auto",
            (sticky === null || sticky === void 0 ? void 0 : sticky.isStuck) === true ? "3" : "inherit"
        ]
    }, "div.__jsx-style-dynamic-selector{overflow-x:".concat(responsive ? "auto" : "visible", "}@media screen and (min-width:").concat(width, "){div.__jsx-style-dynamic-selector{overflow-x:visible}}table.__jsx-style-dynamic-selector{background-color:").concat(colors.white, ";border:").concat(sideBorders ? "solid 1px ".concat(colors.border) : "none", ";border-top:solid 1px ").concat(colors.border, ";border-bottom:solid 1px ").concat(colors.border, ";-webkit-border-radius:").concat(sideBorders ? "8px" : "0", ";-moz-border-radius:").concat(sideBorders ? "8px" : "0", ";border-radius:").concat(sideBorders ? "8px" : "0", ";border-collapse:").concat(sideBorders ? "separate" : "collapse", ";position:relative}table.__jsx-style-dynamic-selector td{border-bottom:1px solid ").concat(colors.border, ";text-align:left;padding:.5rem 1rem;line-height:1rem;font-size:.875rem;color:#000;z-index:1}@media screen and (min-width:").concat(width, "){table.__jsx-style-dynamic-selector th{position:").concat((sticky === null || sticky === void 0 ? void 0 : sticky.top) == null ? "static" : "sticky", ";top:").concat((sticky === null || sticky === void 0 ? void 0 : sticky.top) != null ? "".concat(sticky.top, "px") : "auto", ";z-index:").concat((sticky === null || sticky === void 0 ? void 0 : sticky.isStuck) === true ? "3" : "inherit", "}table.stuck.__jsx-style-dynamic-selector th{-webkit-transform:translate(0,-1px);-moz-transform:translate(0,-1px);-ms-transform:translate(0,-1px);-o-transform:translate(0,-1px);transform:translate(0,-1px);-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}}table.__jsx-style-dynamic-selector tr:last-child td{border-bottom:0}")));
};

//# sourceMappingURL=Table.js.map